import { HttpRequestError } from "@workspace/base-api/fetchJson";

/**
 * HA-265 — removing a line and putting it back (Undo / Restore last removed item).
 */

/** AC3: removing a SENT line needs this operation (the server refuses without `epos:tabs:manage`). */
export const MANAGE_TABS_OPERATION = "staff-terminal-manage-tabs";

export const SENT_ITEM_REMOVE_FORBIDDEN_MESSAGE =
	"You don't have permission to remove items that have been sent. Ask a manager.";

export const NOTHING_TO_RESTORE_MESSAGE =
	"That item can't be restored any more.";

/** AC5: shown once the server has removed the line, with an Undo, for this long. */
export const UNDO_TOAST_MESSAGE = "Item removed";
export const UNDO_TOAST_MS = 5000;

/** The server's refusal code on an HTTP error, if it gave one. */
export const problemCodeOf = (error: unknown): string | undefined => {
	const code =
		error instanceof HttpRequestError ? error.problem?.code : undefined;
	return typeof code === "string" ? code : undefined;
};
